/**
 * Decodifica entity HTML numeriche/named (es. N&#x27;Dicka → N'Dicka).
 * Allineata a pb_hooks/parseFantacalcio.js (niente DOM).
 * @param {unknown} str
 * @returns {string}
 */
export function decodeHtmlEntities(str) {
  let s = String(str ?? '');
  let prev;
  do {
    prev = s;
    s = s
      .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
      .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(parseInt(dec, 10)))
      .replace(/&quot;/gi, '"')
      .replace(/&apos;/gi, "'")
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&amp;/gi, '&');
  } while (s !== prev);
  return s;
}

/** true se la stringa contiene entity HTML da decodificare */
export function hasHtmlEntities(str) {
  return /&(?:#x?[0-9a-fA-F]+|quot|apos|lt|gt|amp);/i.test(String(str ?? ''));
}

/** Solo nome normalizzato (fallback lookup per omonimia). */
export function normalizePlayerNameKey(name) {
  return decodeHtmlEntities(name).toLowerCase().trim();
}

/**
 * Chiave lookup nome+squadra (hydration stats / reconcile).
 * @param {unknown} name
 * @param {unknown} team
 */
export function normalizePlayerLookupKey(name, team) {
  return `${decodeHtmlEntities(name).toLowerCase().trim()}-${decodeHtmlEntities(team).toLowerCase().trim()}`;
}

/**
 * Decodifica name/team sui giocatori della lista (in-place safe: nuova array).
 * @param {Array<object>|null|undefined} players
 * @returns {Array<object>}
 */
export function sanitizePlayerListNames(players) {
  if (!Array.isArray(players)) return [];
  return players.map((p) => {
    if (!p || typeof p !== 'object') return p;
    const name = decodeHtmlEntities(p.name);
    const team = decodeHtmlEntities(p.team);
    if (name === p.name && team === p.team) return p;
    return { ...p, name, team };
  });
}
